import { Sport } from '#src/__generated__/globalTypes.ts';
import { WinterRound } from '#src/atoms/icons/WinterRound.tsx';

import setBackgroundImage from './assets/background/background.webp';
import setLeftBackgroundImage from './assets/background/freeze-left.webp';
import setRightBackgroundImage from './assets/background/freeze-right.webp';
import mobileDecoration from './assets/board/mobile-decoration.webp';
import footballComposeTeam from './assets/compose-team/FootballFieldBackground.webp';
import nbaComposeTeam from './assets/compose-team/NBAFieldBackground.webp';
import playFootballBackgroundImage from './assets/footballBackground.webp';
import playNbaBackgroundImage from './assets/nbaBackground.webp';
import onboardingBackground from './assets/onboarding-background.webp';
import replayDialogFootballBackground from './assets/replayDialog/football.webp';
import replayDialogNBABackground from './assets/replayDialog/nba.webp';
import setLogoImage from './assets/set-logo.svg';
import playVoucherIcon from './assets/voucher.svg';
import commonPacksLogoImage from './assets/wntr-logo.svg';
import cardRevealSwipeIconImage from './assets/wntr-series-icon.svg';

type SetPlaySportAssets = {
  backgroundImage: string;
};

const DEFAULT_SET_PLAY_SPORT_ASSETS: SetPlaySportAssets = {
  backgroundImage: playFootballBackgroundImage,
};

const SET_PLAY_SPORT_ASSETS: Partial<Record<Sport, SetPlaySportAssets>> = {
  [Sport.FOOTBALL]: DEFAULT_SET_PLAY_SPORT_ASSETS,
  [Sport.NBA]: {
    backgroundImage: playNbaBackgroundImage,
  },
};

const background = {
  background: `
      url("${setLeftBackgroundImage}") left  top / contain no-repeat,
      url("${setRightBackgroundImage}") right  top / contain no-repeat,
      url("${setBackgroundImage}") center top / cover no-repeat
    `,
  backgroundBlendMode: 'color-dodge, color-dodge, normal',
};

export const SET_WINTER = {
  displayName: 'Winter',
  slug: 'winter',
  colorTheme: undefined,
  supportedSports: [Sport.FOOTBALL, Sport.NBA] as const,
  cardEditionSlugs: ['winter', 'ice_breaker'] as const,
  skins: [],
  colors: {
    main: 'var(--c-set-winter-surface-primary)',
    swipeEffectColor: '#00A2F3',
    mainRGB: [0, 243, 235] satisfies [number, number, number],
  },
  visual: {
    board: {
      mobileDecoration,
    },
    commonPacks: {
      logoImage: commonPacksLogoImage,
    },
    cardReveal: {
      swipeIconImage: cardRevealSwipeIconImage,
      background,
      videoSources: null,
      newEffectColor: null,
    },
    seasonCountdown: null,
    brand: {
      logoImage: setLogoImage,
      SetLogoImg: null,
      SetIcon: WinterRound,
    },
    play: {
      getSportAssets: (sport: Sport) =>
        SET_PLAY_SPORT_ASSETS[sport] || DEFAULT_SET_PLAY_SPORT_ASSETS,
      voucherIcon: playVoucherIcon,
    },
    replayDialog: {
      background: {
        [Sport.FOOTBALL]: replayDialogFootballBackground,
        [Sport.NBA]: replayDialogNBABackground,
        [Sport.BASEBALL]: undefined,
      },
    },
    welcomePackDialog: null,
    welcomeBackDialog: null,
    referral: null,
    composeTeam: {
      [Sport.FOOTBALL]: footballComposeTeam,
      [Sport.NBA]: nbaComposeTeam,
      [Sport.BASEBALL]: undefined,
    },
    squad: null,
    onboardingBackground: {
      background: `
        linear-gradient(
          to bottom,
          rgba(var(--c-rgb-set-surface-tertiary), 0.7),
          rgba(var(--c-rgb-set-surface-tertiary), 0.7)
        ),
        url(${onboardingBackground}) no-repeat center / cover`,
      backgroundBlendMode: 'multiply, normal',
    },
  },
  background,
  showTeamFilters: false,
  showDefaultCollectionTaskDescription: false,
} as const;
